__turbopack_context__.v({
  "content": "mW4_IW_content",
  "placeholder": "mW4_IW_placeholder",
});
